import { Input, Component, OnInit, HostListener } from '@angular/core';
import { tableGrid } from '../tabledata';
import { userDetail } from '../userdetail';
import { KYCRegister } from '../../Class/CSARegister';
import { KYCAddress } from '../../Class/kycaddress';
import { PaymentDetail } from '../../Class/PaymentDetail';
import { KYC } from '../../Class/kyc';
import { KYCDocument } from '../../Class/kycdocument';
import { KYCUserDetail } from '../../Class/kycuserdetail';
import { DropDown } from '../../Class/dropdown';
import { ResponseData } from '../../Class/response';
import { Registartionservice } from '../../Service/registration.service';
import { AlertService } from '../../Service/alert.service';
import { ToastrService } from 'ngx-toastr';
import { City } from '../../Class/City';
import { NgForm } from '@angular/forms';
import * as ts from "typescript";
import { DomSanitizer } from '@angular/platform-browser';
import { stringify } from '@angular/compiler/src/util';
import { HttpClient } from '@angular/common/http';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { environment } from 'src/environments/environment';

declare var $: any;

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  data: any = []
  public minDate: Date = new Date("05/07/2017");
  public maxDate: Date = new Date("05/27/2017");
  model: any = {};
  modelCompany: any = {};
  modeladdress: any = {};
  modeldocument: any = {};
  modeluseretail: any = {};
  modelkyc: any = {};
  selectedEmployee: KYCRegister;
  kycaddress: KYCAddress[];
  kycaddress1: KYCAddress[];
  kycaddress2: KYCAddress[];
  kycdocument: KYCDocument[];
  kycdocumentobj: KYCDocument;
  kycusertail: KYCUserDetail[];
  responsedata: ResponseData;
  getcompanyid: number;
  selectedfile: File;
  kyc: KYC[];
  KYCList: KYCRegister[];
  status: string;
  portlist: any = [];
  dropdown: DropDown[];
  state: DropDown[];
  city: City[];
  public f: NgForm;
  public companyid: number;
  public cityid: number;
  public stateid: number;
  public saerchpan: number = 0;
  public flag: number = 0;
  public Name: string;
  public Monthyear: string
  public pr: string
  public Mr: string
  public tt: string
  public dateValue: string
  public kk: string;
  public payment: PaymentDetail[];
  public DocumentName : string;
  public KYCDocumentName: string;
  isSubmitBtnDisabled = false;
  btnval = 'Submit & Confirm'


  //Draupadesh
  dropdownList :any;
  selectedItems = []; 
  select1 : any = {};
  select2= [];
  select3= [];
  finalselect: any = {};
  Items: any = {};
  filename=[];
  filenameKyc=[];
  chkflag:any;
  filename2:any;
  fileToUpload: File = null;
  url = '';
  uploaddata = '';
  Logo: '';
  files: FileList;
  drp = [];
  content:number;
  content1:number;
  conp:number;
  id: string
  disableControls = false;
  isBCBAUser :boolean = false;
  disablePayment : boolean = false;
  disableAfterSubmit : boolean = true;
   
  public DocumentType: any = ['PAN Card No', 'IEC License Copy', 'CHA License', 'TAN']

  public DocumentType1: any = ['PAN Card No', 'IEC License Copy', 'CHA License', 'TAN']

  public newDynamic: any = [];
  public dynamicArray: Array<KYCDocument> = [];

  public newDynamicAddress: any = [];
  public dynamicArrayAddress: Array<KYCAddress> = [];

  public newDynamicDetail: any = [];
  public dynamicArrayDetail: Array<tableGrid> = [];

  public newDynamicuser: any = [];
  public dynamicArrayuser: Array<KYCUserDetail> = [];

  public newDynamickyc: any = [];
  public dynamicArraykyc: Array<KYC> = [];
  dropdownSettings: IDropdownSettings;
  constructor(private http: HttpClient, private sanitizer: DomSanitizer, private registerService: Registartionservice, private alertService: AlertService, private toastr: ToastrService) {
      
   }

    getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


ngOnInit() {
 this.id = this.getParameterByName('id');
 if(this.id != undefined || this.id != null){

   // Disabel controll id bcba user
   this.disableControls = true;
   this.isBCBAUser = true;
   this.disablePayment = false;

   this.GetUserDetails(this.id)
   this.GetLoginDetails(this.id);
 }
    this.GetCompanyType();  
    this.content=1
    this.content1=0
      this.conp=0;
    
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      maxHeight: 130,
      itemsShowLimit: 5

    }
    this.newDynamicAddress = { companyId: this.companyid, officeType: "", addressLine: "", addressLine1: "", pinCode: "", emailID: "", contactPersonName: "", MobileNo: "", phoneNo: "", city: "", state: "", country: "" };
    this.dynamicArrayAddress.push(this.newDynamicAddress);

    this.newDynamic = { companyId: "", DocumentType: "", DocumentNo: "", IssueDate: "", validityDate: "", attachment: "" };
    this.dynamicArray.push(this.newDynamic);

    this.newDynamicDetail = { DocumnentType: "", DocumentNo: "", IssueDate: "", ValidatyDate: "", Attachement: "" };
    this.dynamicArrayDetail.push(this.newDynamicDetail);

    this.newDynamicuser = { companyId: "", title: "", FirstName: "", LastName: "", EmailId: "", ContactNo: "", CompanyType: "", Department: "", Actitvities: "", guid:""};
    this.dynamicArrayuser.push(this.newDynamicuser);

    this.newDynamickyc = { companyId: "", KYCType: "", MonthYear: "", Attachment: "" };
    this.dynamicArraykyc.push(this.newDynamickyc);
    this.getPortOfLoading();
    this.getCityList();

    this.fileEvent(this.files)

  }

  onItemSelect(item: any) {
    this.drp.push(item);
  }

  onSelectAll(items: any) {
    this.drp.push(items);
  }

  onItemDeSelect(item: any) {
    this.drp.splice(this.drp.findIndex(a => a.item_id === item.item_id) , 1)
}

onUnSelectAll(items) {
  this.drp.splice(0,this.drp.length)
}
  downloadFile(i) {
    // if (this.fileToUpload == null && this.flag == 0) {
    //   alert("Please choose file");
    //   return;
    // }
    
    if (this.flag == 1) {
      this.registerService.uploadFile1(this.dynamicArray[i].attachment).subscribe(
        response => {
          
          var file = new Blob([response], {

          });
          let link = URL.createObjectURL(file);
          var a = document.createElement('a');
          a.download = this.dynamicArray[i].attachment;
          a.href = link;
          document.body.appendChild(a);
          a.target = '_blank';
          a.click();
        },
      );
    }
    else {
      let link = document.createElement("a");
      
      link.download = this.fileToUpload.name;
      link.href = this.Logo;
      link.click();
    }

  }
  downloadFile1(i) {
    // if (this.fileToUpload == null && this.flag == 0) {
    //   alert("Please choose file");
    //   return;
    // }
    
    //if (this.flag == 1) {
      this.registerService.uploadFile1(this.dynamicArraykyc[i].Attachment).subscribe(
        response => {
          
          var file = new Blob([response], {

          });
          let link = URL.createObjectURL(file);
          var a = document.createElement('a');
          a.download = this.dynamicArraykyc[i].Attachment;
          a.href = link;
          document.body.appendChild(a);
          a.target = '_blank';
          a.click();
        },
      );
  }

  public getPortOfLoading() {
    this.registerService.GetPortList().subscribe((data: any[]) => {
      this.dropdown = data["DropDown"];
      this.getCityList();
    })
  }

  public getPaymentStatus() {
   
    this.saerchpan = 1;
    this.selectedEmployee = this.model;
    if(this.selectedEmployee.panNo==undefined){alert("Please Fill PanNo");return;}
    this.getCompanyDetail()
    this.registerService.GetPaymentHistory(this.selectedEmployee.panNo).subscribe((data: any[]) => {
      this.payment = data;
    })

  }

  public getCompanyDetail() {
    this.content=0;
    this.content1=1;
    this.flag = 1;
    this.selectedEmployee = this.model;
    this.registerService.GetCompanyDetail(this.selectedEmployee.panNo).subscribe((data: any[]) => {
      this.model = data[0];
      
      this.getcompanyid = data[0].id;
      if (this.model.CFS==true) 
      {   
        this.select1 =  { item_id: 1, item_text: 'CFS' };
        this.select2.push(this.select1)   
      }
      if (this.model.CHA==true) { this.select1 ={ item_id: 2, item_text: 'CHA' };this.select2.push(this.select1)}
      if (this.model.Emptyard==true) {    this.select1 = { item_id: 3, item_text: 'Emptyard' }  ; this.select2.push(this.select1)}
      if (this.model.ForwardIssuer==true) {this.select1 ={ item_id: 4, item_text: 'Forward Issuer' }; this.select2.push(this.select1) }   
      if (this.model.ForwardRequest==true) { this.select1 =  { item_id: 5, item_text: 'Forward Request' };this.select2.push(this.select1)    }
      if (this.model.ICD==true) {this.select1 =  { item_id: 6, item_text: 'ICD' } ;  this.select2.push(this.select1) }
      if (this.model.ImportExport==true) { this.select1 =  { item_id: 7, item_text: 'ImportExport' };this.select2.push(this.select1) }
      if (this.model.Consolidator==true) { this.select1 =  { item_id: 8, item_text: 'Consolidator' } ;this.select2.push(this.select1);}
      if (this.model.NVOCC==true) {  this.select1 =  { item_id: 9, item_text: 'NVOCC' };this.select2.push(this.select1);  }
      if (this.model.FreightForward==true) {   this.select1 = { item_id: 10, item_text: 'Freight Forwarder' } ;  this.select2.push(this.select1); } 

      this.selectedItems[0]=  this.select2; 
      this.getCompanyAddress();
      //if (this.model.length <= 0)
        //alert("Please enter company details");
    })
  }

  public getCompanyAddress() {
    this.selectedEmployee = this.model;
    this.registerService.GetCompanyAddress(this.model.id).subscribe((data: any[]) => {
      this.dynamicArrayAddress.length = 0
      for (var x in data) {
        this.dynamicArrayAddress[x] = data[x];
        this.stateid = data[x].state;
        this.onSelect(parseInt(this.dynamicArrayAddress[x].city))
      }
      
      this.getAttachmentDetail();
    
      //if (this.dynamicArrayAddress.length <= 0)
        //alert("Please attache the document type");
    })
  }

  public getAttachmentDetail() {
    this.selectedEmployee = this.model;
    this.registerService.GetAttachmentDetail(this.model.id).subscribe((data: any[]) => {
      this.dynamicArray.length = 0
      for (var x in data) {
        this.dynamicArray[x] = data[x];
        var nameString = this.dynamicArray[x].attachment;
        this.filename[x] = nameString.split('\\').pop().split('/').pop();
      }
      
      this.getKYC();
      //if (this.dynamicArray.length <= 0)
        //alert("Please attach KYC type document");
    })
  }
  public getAttachmentDetail2() {
    this.selectedEmployee = this.model;
    this.registerService.GetAttachmentDetail(this.model.id).subscribe((data: any[]) => {
      this.dynamicArray.length = 0
      for (var x in data) {
        this.dynamicArray[x] = data[x];
        var nameString = this.dynamicArraykyc[x].Attachment;
        this.filename2 = nameString.split('\\').pop().split('/').pop();
      }
      this.getKYC();
      //if (this.dynamicArray.length <= 0)
        //alert("No Data Found for");
    })
  }
  public getKYC() {
    this.selectedEmployee = this.model;
    this.registerService.GetKYC(this.model.id).subscribe((data: any[]) => {
      this.dynamicArraykyc.length = 0
      for (var x in data) {
        this.dynamicArraykyc[x] = data[x];
        var nameKyc = this.dynamicArraykyc[x].Attachment
        this.filenameKyc[x] = nameKyc.split('\\').pop().split('/').pop();

        // this.dynamicArray[x] = data[x];
        // var nameString = this.dynamicArray[x].attachment;
        // this.filename[x] = nameString.split('\\').pop().split('/').pop();
        
      }
      this.getUserDetail();
      //if (this.dynamicArraykyc.length <= 0)
        //alert("Please enter user details");
    })
  }

  public getUserDetail() {
    this.selectedEmployee = this.model;
    this.registerService.GetUserDetail(this.model.id).subscribe((data: any[]) => {
      this.dynamicArrayuser.length = 0
      for (var x in data) {
        this.dynamicArrayuser[x] = data[x];
      }
      //if (this.dynamicArrayuser.length <= 0)
        //alert("Please enter user details");
    })
  }

  public getCityList() {
    this.registerService.GetCityList().subscribe((data: any[]) => {
      this.city = data["CityDropDown"];
    })
  }

  onSelect(countryid: number) {
    this.cityid = countryid;
    this.registerService.GetStateList(countryid).subscribe((data: any[]) => {
      this.state = data["StateDropDown"];
    })
  }

  onSelectState(stateid: number) {
    this.stateid = stateid;
  }

  public getCountryList() {
    this.registerService.GetCountryList().subscribe((data: any[]) => {
      this.dropdown = data["DropDown"];
    })
  }

  addRow(index) {
    this.newDynamic = { companyId: "", DocumentType: "", DocumentNo: "", IssueDate: "", validityDate: "", attachment: "",  CompanyName: this.model.CompnayName};
    this.dynamicArray.push(this.newDynamic);
    this.toastr.success("Address Row Add Successfully");
    //this.toastr.info("hello", "Good");
    return true;
  }

  addRowAddress(index) {
    
    this.newDynamicAddress = { companyId: this.companyid, officeType: "", addressLine: "", addressLine1: "", pinCode: "", emailID: "", contactPersonName: "", MobileNo: "", phoneNo: "", city: "", state: "", country: "" };
    this.dynamicArrayAddress.push(this.newDynamicAddress);
    return true;
  }

  deleteRow(index, id, flag) {
    if (this.dynamicArray.length == 1) {
      return false;
    } else {
      this.dynamicArray.splice(index, 1);
      this.deleteAttachment(id, flag)

      return true;
    }
  }

  deleteAttachment(id, flag){
    this.registerService.deleteAttachment(id, flag)
    .subscribe(data => {
       if(data =='deleted'){
        alert("Attachment deleted");
       }
    },
      error => {
        this.alertService.error(error);
      });
}

  deleteRowAddress(index) {
    if (this.dynamicArrayAddress.length == 1) {
      return false;
    } else {
      this.dynamicArrayAddress.splice(index, 1);
      return true;
    }
  }

  public SaveKYcRegister(btnelement) {

   
    this.selectedEmployee = this.model;
    
       if(this.selectedEmployee.CompnayName==undefined){alert("Please Fill CompanyName");return;}
       if(this.selectedEmployee.panNo==undefined){alert("Please Fill PanNo");return;}
       if(this.selectedEmployee.MobileNo==undefined){alert("Please Fill MobileNo");return;}
       if(this.selectedEmployee.EmailID==undefined){alert("Please Fill EmailId");return;}
       
     for (let i = 0; i < this.drp.length; i++) 
     {
       if(this.drp[i].item_id==2)
       {
         if(this.selectedEmployee.LicenceNo==undefined)
         {
           alert("Please Select LicenseNo For CHA"); var element=document.getElementById('LicenceNo').style.borderColor='red';return;
           
          }
         if(this.selectedEmployee.CHANo==undefined)
         {
           alert("Please Select ChaNo For CHA");document.getElementById("CHANo").style.borderColor="red";return;
         }
       }
  
     }
     
     for (let i = 0; i < this.drp.length; i++) 
     {
       if(this.drp[i].item_id==2 )
       {
         if(this.chkflag!="2")
         {
          this.addRow(i);
          this.chkflag="2";
         }
        
         if(this.dynamicArray[0].DocumentType!="Licences Copy")
         {
          alert("Please Select first Licences Copy and  PAN No for CHA");
          this.dynamicArray[0].DocumentType="Licences Copy";

         return;
         }
        
           if(this.dynamicArray[1].DocumentType!="PAN No")
           {
            alert("Please Select first Licences Copy and  PAN No for CHA");
           
            return;
           }
           
      
        }
         if(this.drp[i].item_id==10)
       {
        if(this.chkflag!="2")
        {
         this.chkflag="2";
        }
      
          if(this.dynamicArray[0].DocumentType!="PAN No")
          {
          alert("Please select PAN No for Freight Forwarder");
          return;
        }
       }
     }

    if(this.dynamicArrayAddress[0].officeType==""){
       
      alert("Please Fill officeType");
      return;
     
    }
    if(this.dynamicArrayAddress[0].pinCode==""){alert("Please Fill PinCode");return;}
    if(this.dynamicArrayAddress[0].contactPersonName==""){alert("Please Fill contactPersonName");return;}
    if(this.dynamicArrayAddress[0].city==""){alert("Please Fill city");return;}
    if(this.dynamicArrayAddress[0].state==""){alert("Please Fill state");return;}
    if(this.dynamicArrayAddress[0].country==""){alert("Please Fill country");return;}
     
    if(this.dynamicArray[0].DocumentType==""){alert("Please Fill DocumentType");return;}
    if(this.dynamicArray[0].DocumentNo==""){alert("Please Fill DocumentNo");return;}
    
     if(this.dynamicArraykyc[0].KYCType==""){alert("Please Fill KYCType");return;}
     if(this.dynamicArraykyc[0].MonthYear==""){alert("Please Fill Monthyear");return;}
     
     if(this.dynamicArrayuser[0].firstName==""){alert("Please Fill FirstName");return;}
     if(this.dynamicArrayuser[0].LastName==undefined){alert("Please Select LastName");return;}
     if(this.dynamicArrayuser[0].emailid==""){alert("Please Fill EmailId");return;}
     if(this.dynamicArrayuser[0].contactno==undefined){alert("Please Select ContactNo");return;}
     if(this.dynamicArrayuser[0].activities==undefined){alert("Please Select Activities");return;}
     
    this.selectedEmployee.CFS = false;
    this.selectedEmployee.CHA = false;
    this.selectedEmployee.Emptyard = false;
    this.selectedEmployee.FreightForwarderissuer = false;
    this.selectedEmployee.FreightForwarderequest = false;
    this.selectedEmployee.ICD = false;
    this.selectedEmployee.ImportExport = false;
    this.selectedEmployee.FreightForward = false;
    this.selectedEmployee.CFS = false;
    this.selectedEmployee.UserCount = this.dynamicArrayuser.length
    
    if (this.selectedEmployee.companyType == 'CHA')
    {
      this.selectedEmployee.CHA = true; 
    }
    else if(this.selectedEmployee.companyType == 'CFS')
    {
      this.selectedEmployee.CFS = true; 
    }
    else if(this.selectedEmployee.companyType == 'FF')
    {
      this.selectedEmployee.FreightForward = true; 
    }
    else if(this.selectedEmployee.companyType == 'IE')
    {
      this.selectedEmployee.ImportExport = true; 
    }

    this.selectedEmployee.IpAddress = '';
    this.selectedEmployee.Status = '';
    this.selectedEmployee.CreatedDate = '';
    
    if (!this.getcompanyid)
      this.companyid = this.model.Id;
    else
      this.companyid = this.getcompanyid;


      // Disabling submit button.
      this.disableAfterSubmit = false;

      // Changing button text after click
        this.btnval = "Processing please wait...";

        this.selectedEmployee.isBCBAUser =  this.isBCBAUser
    this.registerService.SaveKycRegister(this.selectedEmployee)
      .subscribe(data => {
        this.companyid = data["Id"];
        
        this.alertService.success('Registration successfull', true);
        if (this.companyid > 0)
         
          this.adddocument();
      },
        error => {
          this.alertService.error(error);
        });
  }

  public adddocument() {
    if (!this.companyid) {
           
      this.dynamicArray[0].companyId = this.getcompanyid;
     
      this.dynamicArrayuser[0].companyId = this.getcompanyid;
      this.dynamicArrayAddress[0].companyID = this.getcompanyid;
      this.dynamicArraykyc[0].companyId = this.getcompanyid;
    }
    else {
      this.dynamicArray[0].companyId = this.companyid;
      this.dynamicArrayuser[0].companyId = this.companyid;
      this.dynamicArrayAddress[0].companyID = this.companyid;
      this.dynamicArraykyc[0].companyId = this.companyid;
    }

    this.dynamicArray[0].CompanyName  = this.model.CompnayName;

   
   
    // this.dynamicArray.forEach(function (doc) {
    //     doc.CompanyName = this.model.CompnayName;
    //     doc.companyId = this.companyid;
    // });

    for (var data in this.dynamicArray) {
      this.dynamicArray[data].CompanyName = this.model.CompnayName
      this.dynamicArray[data].companyId = this.companyid; 
      if(this.isBCBAUser){
        this.dynamicArray[data].attachment = this.DocumentName
      }
    }

    this.registerService.SaveKycDocument(this.dynamicArray)
      .subscribe(
        data => {
          this.addkycaddress();
        },
        error => {
          this.alertService.error(error);
        });
  }

  public addkycaddress() {
    if (this.cityid > 0) {
      this.dynamicArrayAddress[0].city = this.cityid.toString();
      this.dynamicArrayAddress[0].state = this.stateid.toString();
    }
    this.registerService.SaveKycAdress(this.dynamicArrayAddress)
      .subscribe(
        data => {
          this.alertService.success('Registration successful', true);

          this.adduserdetail();
        },
        error => {
          this.alertService.error(error);
        });
  }

  public adduserdetail() {
    for (var data in this.dynamicArrayuser) {
      this.dynamicArrayuser[data].guid = this.id; 
      this.dynamicArrayuser[data].companyId = this.companyid
      this.dynamicArrayuser[data].CompnayName = this.modelCompany.CompnayName
      this.dynamicArrayuser[data].contactno = this.dynamicArrayuser[data].contactno
      this.dynamicArrayuser[data].isBCBAUser = this.isBCBAUser;
    }
    this.dynamicArrayuser[0].guid = this.id;
    //this.dynamicArrayuser[0].isBCBAUser = this.isBCBAUser;
    
    this.registerService.SaveKycUserDetail(this.dynamicArrayuser)
      .subscribe(
        data => {
          this.alertService.success('Registration successful', true);
          this.addkyc();
        },
        error => {
          this.alertService.error(error);
        });
  }

  public clear() {
    this.dynamicArrayAddress[0].officeType = null;
    this.dynamicArrayAddress[0].contactPersonName = null;
    this.dynamicArrayAddress[0].country = null;
    this.dynamicArrayAddress[0].emailID = null;
    this.dynamicArrayAddress[0].addressLine1 = null;
    this.dynamicArrayAddress[0].addressLine = null;
    this.dynamicArrayAddress[0].city = null;
    this.dynamicArrayAddress[0].pinCode = null;

    this.dynamicArraykyc[0].KYCType = null;
    this.dynamicArraykyc[0].MonthYear = null;
    this.dynamicArraykyc[0].Attachment = null;

    this.dynamicArrayuser[0].firstName = null;
    this.dynamicArrayuser[0].LastName = null;
    this.dynamicArrayuser[0].emailid = null;
    this.dynamicArrayuser[0].department = null;
    this.dynamicArrayuser[0].activities = null;
    this.dynamicArrayuser[0].MobileNo = null;
    

    this.dynamicArray[0].DocumentType = null;
    this.dynamicArray[0].DocumentNo = null;
    this.dynamicArray[0].IssueDate = null;
    this.dynamicArray[0].validityDate = null;
    this.dynamicArray[0].attachment = null;

  }

  public addkyc() {
    for (var data in this.dynamicArraykyc) {
      this.dynamicArraykyc[data].CompanyName = this.model.CompnayName
      this.dynamicArraykyc[data].companyId = this.companyid; 
    }
    this.registerService.SaveKyc(this.dynamicArraykyc)
      .subscribe(
        data => {
          if(this.id != undefined || this.id != null){
            this.btnval = "Completed";
            if( this.isBCBAUser == true)
            {
              if (this.companyid > 0)
              {
                alert("You KYC submitted, now you can proceed with paymnet.");
                window.open(environment.packageEnv +this.companyid )
              }
              else if(this.getcompanyid>0)
              { 
               alert("You KYC submitted, now you ca proceed with paymnet.");
               window.open(environment.packageEnv +this.getcompanyid )
              }
            }
            else{
              alert("Dear Valued Customer,\nWe are pleased to inform you that your documents have been successfully uploaded. For the next steps, please reach out to our KYC representative on 08069022222. Email- KYC@mastergroups.com");
              window.location.href='https://mmd3.mastergroups.com/'
            }
          }
          else{
            alert("Dear Valued Customer, \n We are pleased to inform you that your documents have been successfully uploaded. For the next steps, please reach out to our KYC representative on 08069022222. Email- KYC@mastergroups.com");
            window.location.href='https://mmd3.mastergroups.com/'
          }
          // else{
          //   alert("Your request has been forwarded to the backend team. Will confirm you once KYC is verified.");
          //   window.location.href='https://mmd3.mastergroups.com/'
          // }
        },
        error => {
          this.alertService.error(error);
        });
  }

  addRowuser(index) {
    this.newDynamicuser = { companyId: this.companyid, title: "", FirstName: "", LastName: "", EmailId: "", ContactNo: "", CompanyType: "", Department: "", Actitvities: "", guid:"" };
    this.dynamicArrayuser.push(this.newDynamicuser);
    return true;
  }

  deleteRowuser(index, id , flag) {
    if (this.dynamicArrayuser.length == 1) {
      return false;
    } else {
      this.dynamicArrayuser.splice(index, 1);
      this.deleteAttachment(id, flag)
      return true;
    }
  }

  addRowkyc(index) {
    this.newDynamickyc = { companyId: this.companyid, KYCType: "", Monthyear: "", Attachment: "" };
    this.dynamicArraykyc.push(this.newDynamickyc);
    return true;
  }

  deleteRowkyc(index, id ,flag) {
    if (this.dynamicArraykyc.length == 1) {
      return false;
    } else {
      this.dynamicArraykyc.splice(index, 1);
      this.deleteAttachment(id, flag)
      return true;
    }
  }

  public fileEvent(files: FileList) {
    this.fileToUpload = files.item(0);
    this.uploaddata = this.fileToUpload.name;

    var reader = new FileReader();

    reader.readAsDataURL(files[0]); // read file as data url

    reader.onload = (event: any) => { // called once readAsDataURL is completed
      this.Logo = event.target.result;
    }
if(this.model.CompnayName == undefined || this.model.CompanyName == "")
{
  alert('Please enter company name')
  return;
}

    this.registerService.UploadImageNew( this.model.CompnayName, this.fileToUpload).subscribe(
      response => {
        var res = response;
        
        if (res == "Please Upload PDF,JPG,JPEG,PNG  only") {
          
        
          this.dynamicArray[0].attachment = null;

          this.dynamicArraykyc[0].Attachment=null;
          alert(res);
        }
        else {
          alert(res);
        }
      },
    );
  }

  public Payment() {

    if(this.isBCBAUser)
    {
      if (this.companyid > 0)
      {
      window.open(environment.packageEnv +this.companyid )
      }
      else if(this.getcompanyid>0)
      { 
        window.open(environment.packageEnv +this.getcompanyid )
      }
      else
      {
        alert("Kindly submit KYF before making payment");
      }
    }
    else
    {
      if (this.companyid > 0)
      //window.open("http://payment.mmd3.in/package-list/" + this.companyid)
      window.open(environment.packageEnv +this.companyid )
      else if(this.getcompanyid>0)
      window.open("http://payment.mmd3.in/package-list/" + this.getcompanyid)
      //window.open(environment.packageEnv +this.getcompanyid )
      else
      alert("Kindly submit KYF before making payment");
    }

  
  }
  public AddAddress() {
    var element = document.getElementById("tab2");
    var element1 = document.getElementsByClassName('active');
    element.classList.remove('invisible')
    element.classList.add('active');
  }

  public pickDate() {
    $('#datetimepicker1').datepicker({
      format: 'dd/mm/yyyy'
    });
  }

  public GotoTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollFunction();
  }

  public scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("myBtn").style.display = "block";
    } else {
      document.getElementById("myBtn").style.display = "none";
    }
  }

  public GetCompanyType()
  {
    this.registerService.GetCompanyType()
       .subscribe( data => {
              this.dropdownList=data;
         },
         error => {
           this.alertService.error(error);
         });
  }
public GetUserDetails( guid: string)
{
  this.registerService.GetUserDetails(guid ).subscribe((data: any[]) => {
    // for (var x in data) {
    //   this.dynamicArrayuser[x] = data[x];
    // }
  });
}

public GetLoginDetails(guid : string){
  this.registerService.GetLoginDetails(guid ).subscribe((data: any[]) => {
    if(data != undefined || data != null)
    {
     this.modelCompany.CompnayName  = data[0]["CompanyName"];
     this.companyid = data[0]["CompanyName"];
     this.modelCompany.panNo  =   data[0]["PANNo"];
     this.modelCompany.MobileNo = data[0]["companyMobile"];
     this.modelCompany.EmailID = data[0]["companyEmail"]
     this.modelCompany.SeaPort = data[0]["SeaPort"]
     this.modelCompany.CHANo = data[0]["CBNo"]
     this.modelCompany.CHANo = data[0]["CBNo"]
     this.modelCompany.CompanyType = data[0]["CompanyType"]
     this.DocumentName = data[0]["DocName"]
     this.KYCDocumentName = data[0]["KycDocName"]
     this.registerService.uploadBCBAFile(this.id).subscribe();

     if(data[0]["CompanyType"].length > 0 && (data[0]["CompanyType"] == 'CHA'))
    {
    }
     this.model = this.modelCompany
    
     for (var x in data) {
      this.dynamicArrayuser[x] = data[x]
    }

    for (var x in data) {
      this.dynamicArrayuser[x].firstName = data[x]["UserFirstName"]
      this.dynamicArrayuser[x].LastName = data[x]["UserLastName"]
      this.dynamicArrayuser[x].emailid = data[x]["EmailId"]
      this.dynamicArrayuser[x].title = data[x]["UserSalutation"]
      this.dynamicArrayuser[x].department = data[x]["UserDepartment"]
      this.dynamicArrayuser[x].activities = data[x]["UserActivities"]
      this.dynamicArrayuser[x].contactno = data[x]["MobileNo"]
      this.dynamicArrayuser[x].CompnayName = data[x]["CompanyName"]
    }
    }

    for (var x in data) {
      this.dynamicArrayAddress[x].addressLine = data[x]["OfficeAddress"];
      this.dynamicArrayAddress[x].pinCode = data[x]["Pincode"];
      this.dynamicArrayAddress[x].contactPersonName = data[x]["ContactPersonName"];
      this.dynamicArrayAddress[x].city = data[x]["CityId"];
      this.dynamicArrayAddress[x].state = data[x]["StateId"];
      this.stateid =  data[x]["StateId"];
      this.dynamicArrayAddress[x].officeType = data[x]["OfficeType"];
      this.dynamicArrayAddress[x].country = data[x]["CountryName"];

      // Document type

      this.dynamicArray[x].DocumentType = data[x]["DocType"];
      this.dynamicArray[x].DocumentNo = data[x]["DocNo"];

    // KYC type
    this.dynamicArraykyc[x].KYCType = data[x]["KycType"];
    this.dynamicArraykyc[x].MonthYear = data[x]["KycMonth"];
    this.dynamicArraykyc[x].Attachment = data[x]["KycDocName"];

      this.onSelect(parseInt(this.dynamicArrayAddress[x].city))
    }
});
}

UpdateData(){
  window.document.location.href = 'https://bcba.ngauge.co.in/UpdateMemberUser.aspx?Guid=' + this.id 
  }
}
  
 
